import { computed, ComputedRef, Ref, ref, watchEffect } from 'vue'
import { FeatureFlagsState } from '../models/featureFlag'
import { useAuthSiteStore } from '../../user/authSiteStore'
import { storeToRefs } from 'pinia'


export type FeatureFlagName = 'TIME_OFF'

const defaultFlags: FeatureFlagsState = {
    TIME_OFF: false,
}

const featureFlagsState: Ref<FeatureFlagsState> = ref(defaultFlags)

export function useFeatureFlags() {
    const authSiteStore = useAuthSiteStore()
    const { currentConfig } = storeToRefs(authSiteStore)

    watchEffect(() => {
        if (currentConfig.value) {
            featureFlagsState.value = {
                ...defaultFlags,
                TIME_OFF: currentConfig.value.features.timeOffEnabled,
            }
        }
    })

    const isFeatureEnabled = (flag: FeatureFlagName): ComputedRef<boolean> => {
        return computed(() => featureFlagsState.value[flag] === true)
    }

    const isEnabledForRegion = computed(() => {
        return (import.meta.env.VITE_APP_API_URL as string) !== 'https://nw.api.clinishift.us'
    })

    return {
        isFeatureEnabled,
        isEnabledForRegion,
    }
}